import colors from "../../base/colors";

const { secondary } = colors;

const formLabel = {
  styleOverrides: {
    root: {
      color: secondary.main,
      fontVariant: "all-small-caps",
    },
  },
};
export default formLabel;
